<body class="background-violet-500">
    <app-nav-menu #menu (stateChanged)="updateHeight($event)"></app-nav-menu>

    <div #tata class="container-fluid background rounded-top border" [style.height]="PageHeight" [style.overflow-y]="Overflow">
        <router-outlet></router-outlet>
    </div>
</body>